import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { ProgressBarFactory } from "../../factories/ProgressBarFactory"
import { EditorComponentContract } from '../EditorComponentContract'

export class ProgressBar extends EditorComponentContract {
  constructor() {
    super(Variations);
    this.htmlBuilder = HtmlBuilder
    this.factory = new ProgressBarFactory
  }

  info() {
    return {
      name: 'ProgressBar',
      icon: 'fa-battery-half',
      variations: this.variationsInfo()
    }
  }

  elementIds() {
    return ['id', 'containerId', 'textId']
  }

  elementClasses() {
    return ['classes', 'containerClasses', 'textClasses']
  }

  elementContents() {
    return ['hasTitle', 'text', 'progressWidth']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
      {id: 'containerId', element: 'id', styles: 'containerStyles', selector: '#', variation: null},
      {id: 'textId', element: 'id', styles: 'textStyles', selector: '#', variation: null},
    ]
  }
}
